import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Flex } from 'antd';
import { AppFooter } from '@components/AppFooter';
import { PageURL } from '../../router/pageURL';
import { AgreementPage, CreateAccountPage } from '@pages/SignupPage/CreateAccountPage';
import { CreateOrganisation } from './CreateOrganisation/CreateOrganisation';
import { BrokerAddress } from '@pages/SignupPage/BrokerAddress';
import { NewSignupPageSectionEnum } from './enums';
import { config } from '@utils/config';
import { useAuth } from '@providers/AuthProvider/AuthContext';
import { useBrokerOnboarding } from '@queries/broker/useBrokerOnboarding';
export const SignupPageProd = () => {
  const [searchParams] = useSearchParams();
  const { isLoaded, isSignedIn } = useAuth();
  const { data: brokerOnboarding, isFetched: isBrokerOnboardingFetched } = useBrokerOnboarding();
  const navigate = useNavigate();
  const formSection = searchParams.get('section') as NewSignupPageSectionEnum;
  const rawSection = searchParams.get('section');

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (!isSignedIn) {
      return;
    }

    if (!isBrokerOnboardingFetched) {
      return;
    }

    const targetSection = brokerOnboarding?.section ?? NewSignupPageSectionEnum.POST_SIGN_UP_PAGE;

    if (targetSection === NewSignupPageSectionEnum.COMPLETED) {
      navigate(PageURL.ROOT);
      return;
    }

    if (rawSection === targetSection) {
      return;
    }

    navigate(`${PageURL.SIGNUP}?section=${targetSection}`, { replace: true });
  }, [brokerOnboarding?.section, isBrokerOnboardingFetched, isLoaded, isSignedIn, navigate, rawSection]);

  const content = useMemo(() => {
    switch (formSection) {
      case NewSignupPageSectionEnum.POST_SIGN_UP_PAGE:
        return <AgreementPage />;
      case NewSignupPageSectionEnum.CREATE_ORGANISATION:
        return <CreateOrganisation />;
      case NewSignupPageSectionEnum.ADDRESS:
        return <BrokerAddress />;
      default:
        return isSignedIn ? null : <CreateAccountPage />;
    }
  }, [formSection, isSignedIn]);

  return (
    <div className='min-h-screen grid grid-rows-[1fr_auto]'>
      <main>
        <Flex vertical justify={'center'} className={'mx-auto size-full max-w-[1200px] px-4 sm:px-6'}>
          <div className={'flex justify-center'}>{content}</div>
        </Flex>
      </main>
      <AppFooter />
    </div>
  );
};

export const SignupPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (config.isLocalAuth) {
      navigate(PageURL.ROOT);
    }
  }, [navigate]);

  if (config.isLocalAuth) {
    return (
      <div className='flex flex-col items-center justify-center p-8 text-gray-600'>
        <p>Local dev: you are signed in. Set VITE_USE_LOCAL_AUTH=false to use Clerk login.</p>
      </div>
    );
  }

  return <SignupPageProd />;
};
